import { render, staticRenderFns } from "./FormsWork.vue?vue&type=template&id=63b550d7&scoped=true"
import script from "./FormsWork.vue?vue&type=script&lang=js"
export * from "./FormsWork.vue?vue&type=script&lang=js"
import style0 from "./FormsWork.vue?vue&type=style&index=0&id=63b550d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b550d7",
  null
  
)

export default component.exports